import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { Box, Grid, Stack } from "@mui/material";
import { useAppStore } from "@/global/store";
import { DynamicSkeleton } from "@/shared/base/components/DynamicSkeleton/DynamicSkeleton";
import { ActiveEvent } from "./ActiveEvent";
import { useAppSystem } from "@/global/hooks/useAppSystem";
import { calcIsEventCardDisabled } from "../utils.purchaseSeats";
import { selectPackageSelected } from "@/global/store/data/purchaseSeats/packages";
import { selectCartManager } from "@/global/store/data/purchaseSeats/cartManager";
import { selectInventory } from "@/global/store/data/purchaseSeats/inventories";
import { useBuckets } from "../Buckets/useBuckets";
import { usePacks } from "../Packs/usePacks";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useSelectActiveEvent } from "./useSelectActiveEvent";

interface ChooseSeatsHeaderProps {
  isLoading?: boolean;
}

export function ChooseSeatsHeader(props: ChooseSeatsHeaderProps) {
  const { md: mdDown } = useCssMediaQuery("down");
  const { theme, teamConfig } = useAppSystem();
  const { activeEvent } = useSelectActiveEvent();
  const selectedPackage = useAppStore(selectPackageSelected);
  const cartState = useAppStore(selectCartManager);
  const inventories = useAppStore(selectInventory(activeEvent?.eventCode));
  const { isBucketsEnabled, isPrimaryBucketsSelected } = useBuckets();
  const { isPacksEnabled } = usePacks();
  const { packageConfigs } = useTeamConfig();

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      sx={{
        borderTop: "1px solid",
        borderBottom: "1px solid",
        borderColor: theme.palette.divider,
      }}
    >
      {props.isLoading ? (
        <Grid container spacing={2} py={1}>
          {Array.from({ length: mdDown ? 2 : 4 })
            .fill(1)
            .map((itm, idx) => {
              return (
                <Grid key={idx} item xs={6} sm={6} md={3}>
                  <DynamicSkeleton
                    rowCount={1}
                    spacing={0}
                    widths={["100%"]}
                    heights={["24px"]}
                  />
                </Grid>
              );
            })}
        </Grid>
      ) : null}

      {!props.isLoading && activeEvent ? (
        <>
          <Box py={1}>
            {activeEvent ? <ActiveEvent event={activeEvent} /> : null}
          </Box>

          <Box></Box>
        </>
      ) : null}
    </Stack>
  );
}
